import axios from "axios";
import { useAuthStore } from "../stores/auth";
import { currentLocale } from "@/i18n";
import { requestStarted, requestFinished } from "./loading";


const api = axios.create({
  baseURL: process.env.VUE_APP_API_URL, // global API URL
  // withCredentials: true, 
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const auth = useAuthStore();
  config.headers["Accept-Language"] = currentLocale();
  if (auth.token) {
    config.headers.Authorization = `Bearer ${auth.token}`;
  }
  return config;
});



// ✅ Response interceptor
api.interceptors.response.use(
  (response) => response, // pass through if success
  (error) => {
    if (error.response && error.response.status === 401) {
      const auth = useAuthStore();
      auth.clearAuth();

      // Optional: redirect to login page
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);
// Top progress bar (utils/loading.ts): count in-flight requests. The flag on
// the config makes sure every started request is finished exactly once.
type TrackedConfig = { __uiLoading?: boolean };
function finishTracked(config?: TrackedConfig) {
  if (config?.__uiLoading) {
    config.__uiLoading = false;
    requestFinished();
  }
}
api.interceptors.request.use((config) => {
  (config as TrackedConfig).__uiLoading = true;
  requestStarted();
  return config;
});
api.interceptors.response.use(
  (response) => {
    finishTracked(response.config as TrackedConfig);
    return response;
  },
  (error) => {
    finishTracked(error?.config as TrackedConfig);
    return Promise.reject(error);
  }
);

export default api;
